import type { FaireProductEntity } from "../../entity_types/product";

export const p_nfwfju3v3h: FaireProductEntity = {
  token: "p_nfwfju3v3h",
  type: "product",
  name: "Italian Infused Extra Virgin Olive Oil in Tin - 100ml",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/8545d3bde3927bbd753c948144931443f03894e0eda1a993dda3a6155093e592.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/335fb28fe0635dd1b2b18046ade621b2d82a5294de55be22657f373848ba9fa2.jpeg",
    "https://cdn.faire.com/fastly/5321776b2891530faf4c03b127a8b4800e76b00035b5b3648efb8af2480698ed.jpeg",
    "https://cdn.faire.com/fastly/d5351cd69ffe69c21026f7dbb31f8328197775a594503fed94d7f7dbb319ff0a.jpeg",
    "https://cdn.faire.com/fastly/899d2b68284fdcf8e49deddfe5e2423388013cc54dc5c63789be019c873a114e.jpeg",
    "https://cdn.faire.com/fastly/79cbf71f7b6cc4f9992b8953b8370568b9d167836edbda8900e267750052190b.jpeg",
    "https://cdn.faire.com/fastly/c1fd792d9187e036346105829bf3cf7120de062aaba94f34c511951fa1441e21.jpeg",
    "https://cdn.faire.com/fastly/707617ebcf2b1fb31a8a98e005e032c7dae16f57db12c4ad783c91ddafe508f3.jpeg",
  ],
  priceDollars: 9,
  description:
    "These gourmet extra virgin olive oils are perfect for salad dressings, marinades, or as a dip for crusty bread. Produced on an Italian farm by Tenuta Sant'Ilario, this EVOO comes in different infused flavors to give your meals an additional level of flavor. Packaged in decorative tins to protect the integrity of the oil. Each tin is 100ml. Set of 3 includes Chili, Garlic, and Basil in an acetate box.\n\nCHILI: infused with chili peppers, the PEPERONCINO flavor gives your meals an additional level of flavor.\n\nGARLIC: The intense and sweet aroma of this garlic, or AGLIO, olive oil is ideal for meats, stews, vegetables, and in the preparation of sauces and salads.\n\nLEMON: Infused with the sweet and sour taste of lemon, this LIMONE infused oil gives dishes zest. \n\nBASIL: This delicate BASILICO extra virgin olive oil compacts the basil aroma and essence with every spoonful. Ideal uses include drizzling on top of bruschetta or pizza, brushing on grilled fish, or enhancing the taste of salads.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:55:01.487Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
